import React from "react";
import Chip from "@material-ui/core/Chip";

const Counter = (props) => {
  return <Chip label={props.children} color="secondary" variant="outlined" />;
};

export default Counter;
